module.exports = {
      id: "liveupdate-usage",
      viewBox: "0 0 14.54 20",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#liveupdate",
      toString: function () {
        return this.url;
      }
    }